<template>
	<AppHeader
		:logo="logo"
		:headerButton1="headerButton1"
		:headerButton2="headerButton2"
	/>

	<div class="flex-grow-1">
		<UiElement class="d-flex flex-column h-100 py-0" :settings="appearance.body.settings">
			<div class="flex-grow-1">
				<UiText :settings="text1" class="text-center" content="2/3">
				</UiText>

				<UiText :settings="heading1" class="text-center" :content="t('shrnuti')">
				</UiText>

				<hr class="border-3" style="color: #000; opacity: 1;">

				<ProductsList :products="cart">
					<template #item="item">
						<div class="d-flex align-items-start">
							<img
								src="/images/remove.png"
								class="me-4"
								width="36"
								height="36"
								alt=""
								@touchstart="removeAllByProductId(item.product_order_index)"
							/>

							<div class="d-flex flex-row justify-content-between align-items-start flex-grow-1 pe-4">
								<UiText :settings="heading2" :content="item.label">
								</UiText>

								<UiText
									:settings="heading2"
									class="ps-3"
									:content="`${ formatNumberWithSpaces(smartNumberFormat((Number(item.price) + getModifiersTotal(item)) * Number(item.amount))) }&nbsp;${currency}`"
								/>
							</div>

							<UiButtonAmount :product="item" :settings="buttonAmount3">
								<template #default="{ count }">
									<UiText :settings="textAmount2" :content="count" />
								</template>
							</UiButtonAmount>
						</div>

						<div v-if="item.modifiers?.length">
							<UiText
								v-for="mod in item.modifiers"
								:key="mod.id"
								:settings="heading2"
								class="d-flex justify-content-between text-muted"
								:content="`+ ${getTranslatedName(mod)}`"
							/>
							<!--:content="`+ ${getTranslatedName(mod)} (x${item.amount}) ${ Math.round(smartNumberFormat(mod.price * Number(item.amount))) }&nbsp;${currency}`"-->
						</div>

						<div v-if="item.notes?.length">
							<UiText
								v-for="mod in item.notes"
								:key="mod.id"
								:settings="heading2" class="d-flex justify-content-between text-muted"
								:content="`+ ${getTranslatedName(mod)} ${smartNumberFormat(mod.inMenuPrice)}&nbsp;${currency}`"
							/>
						</div>

						<hr class="border-3" style="color: #000; opacity: 1;">
					</template>
				</ProductsList>

				<div>
					<template v-if="hasTips">
						<div v-if="false"> class="d-flex align-items-center justify-content-between">
							<UiText :settings="heading3" class="text-end" :content="t('subTotal')">
							</UiText>

							<UiText :settings="heading4" class="text-end" :content="`${ formatNumberWithSpaces(smartNumberFormat(subtotal)) }&nbsp;${currency}`">
							</UiText>
						</div>

						<hr v-if="false" class="border-3" style="color: #000; opacity: 1;">

						<div v-if="tips !== 0" class="d-flex align-items-center justify-content-between">
							<img
								src="/images/remove.png"
								class="me-4"
								width="36"
								height="36"
								alt=""
								@touchstart="tips = 0"
							/>

							<div class="d-flex flex-row justify-content-between align-items-start flex-grow-1">
								<UiText :settings="heading3" class="text-end" :content="t('tips')" />

								<UiText
									:settings="heading3"
									class="text-end"
									tyle="margin-right:185px"
									:content="`${ formatNumberWithSpaces(Math.round(smartNumberFormat(Number(subtotal) / 100 * tips))) }&nbsp;${currency}`"
								>
									<!--TODO: Fix content above-->
								</UiText>
							</div>
						</div>

						<hr v-if="tips !== 0" class="border-5" style="color: #000; opacity: 1;">
					</template>

					<div>
						<UiText :settings="heading3" class="text-end" :content="t('total')">
						</UiText>

						<hr class="border-5" style="color: #000; opacity: 1;">

						<UiText :settings="heading4" class="text-end" :content="`${ formatNumberWithSpaces(smartNumberFormat(total + tipsAmount)) }&nbsp;${currency}`">
						</UiText>
					</div>
				</div>

				<div v-if="hasTips">
					<div style="margin-top:122px" />

					<UiText :settings="heading3" :content="t('tips') + ':'" />

					<div class="d-flex justify-content-between gap-4">
						<UiButton
							v-for="option in normalizeArray(page.options.tipsOptions.value, true)"
							:content="`${option}%<br><span style='font-size:24px'>(${formatNumberWithSpaces(Math.round(Number(subtotal) / 100 * option))} ${currency})</span>`"
							:key="`tip-option-${option}`"
							:settings="buttonModifiers"
							:active="tips === option"
							style="height: initial"
							class="w-100 px-0 py-0"
							disable-hover
							@mousedown="tips = option"
						>
						</UiButton>
					</div>
				</div>
			</div>

			<UiElement class="position-sticky bottom-0 start-0 w-100 px-0" :settings="appearance.body.settings">
				<div class="d-flex gap-4 justify-content-between">
					<UiButtonArrow
						:settings="button1"
						:body="appearance.body.settings"
						style="max-width: 50% !important"
						@touchstart="goBack"
						:content="t('back')"
					/>

					<UiButtonArrow
						:settings="button2"
						:body="appearance.body.settings"
						:content="t('pay')"
						style="max-width: 50% !important"
						@touchstart="goPay"
						class="max-w-50"
						right
					/>
				</div>
			</UiElement>

			<UiText
				v-if="hasDisclaimer || isDemo"
				:settings="text2"
				class="text-center"
				style="margin-bottom:20px"
				:content="t('disclaimer')"
			/>

			<UiText
				:settings="text2"
				class="text-center"
				style="margin-bottom:42px"
				:content="t('disclaimer2')"
			/>
		</UiElement>
	</div>

	<DialogUpsell :show="isDialogVisible || isShowUpsell" :products="recommendedProducts" @close="isShowUpsell = false" />
</template>

<script setup>
	import { ref, computed, onMounted, watchEffect } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useRouter } from 'vue-router';

	import { useThemeStore } from '@/stores/useThemeStore';
	import { useOrderStore } from '@/stores/useOrderStore';
	import { useCatalogStore } from '@/stores/useCatalogStore';

	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useTranslation } from '@/composables/useTranslation';
	import { useKioskRoute } from '@/composables/useKioskRoute';
	import { useDataUtils } from '@/composables/useDataUtils';

	import UiElement from '@/components/UI/UiElement.vue';
	import UiText from '@/components/UI/UiText.vue';
	import UiButtonArrow from '@/components/UI/UiButtonArrow.vue';
	import ProductsList from '@/components/ProductsList.vue';
	import UiButtonAmount from '@/components/UI/UiButtonAmount.vue';
	import UiButton from '@/components/UI/UiButton.vue';
	import AppHeader from '@/components/AppHeader.vue';
	import DialogUpsell from '@/components/Dialogs/DialogUpsell.vue';
	import { useKioskStore } from '@/stores/useKioskStore';

	const { normalizeArray, smartNumberFormat, formatNumberWithSpaces } = useDataUtils();
	const { t } = useTranslation();

	const router = useRouter();

	const catalogStore = useCatalogStore();
	const themeStore = useThemeStore();
	const orderStore = useOrderStore();
	const kioskStore = useKioskStore();
	const { removeAllByProductId } = orderStore;

	const { makePath } = useKioskRoute();
	const { getTranslatedName } = catalogStore;

	const isDemo = ref(false);

	const { theme } = storeToRefs(themeStore);
	const { currency } = storeToRefs(kioskStore);
	const { cart, total, tips, subtotal, tipsAmount } = storeToRefs(orderStore);

	const isShowUpsell = ref(false);
	const recommendedProducts = ref([]);
	const isDialogVisible = computed(() => {
		return !!router?.currentRoute?.value?.query?.dialog;
	});

	const general = computed(() => theme.value.general);
	const page = computed(() => theme.value.pages.summary);
	const appearance = computed(() => page.value.appearance);
	const elements = computed(() => page.value.elements);
	const hasTips = computed(() => {
		return page.value.options.tips.value === true || page.value.options.tips.value === 'true';
	});

	const text1 = useInheritedSettings(computed(() => elements.value?.text1));
	const text2 = useInheritedSettings(computed(() => elements.value?.text2));
	const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));
	const heading2 = useInheritedSettings(computed(() => elements.value?.heading2));
	const heading3 = useInheritedSettings(computed(() => elements.value?.heading3));
	const heading4 = useInheritedSettings(computed(() => elements.value?.heading4));
	const button1 = useInheritedSettings(computed(() => elements.value?.button1));
	const button2 = useInheritedSettings(computed(() => elements.value?.button2));
	const buttonModifiers = useInheritedSettings(computed(() => elements.value?.buttonModifiers));
	const buttonAmount3 = useInheritedSettings(computed(() => general.value?.elements?.buttonAmount3));
	const textAmount2 = useInheritedSettings(computed(() => general.value?.elements?.textAmount2));

	const logo = useInheritedSettings(computed(() => elements.value?.logo));
	const headerButton1 = useInheritedSettings(computed(() => elements.value?.headerButton1));
	const headerButton2 = useInheritedSettings(computed(() => elements.value?.headerButton2));

	const hasDisclaimer = computed(() => {
		return cart.value.some(item =>
			item.details?.disclamer === 1 ||
			item.modifiers.some(mod => mod.disclamer === 1) ||
			item.notes.some(note => note.disclamer === 1)
		)
	});

	const usedCids = computed(() => {
		const cids = new Set();

		cart.value.forEach(item => {
			if (item.details?.cid) cids.add(item.details.cid);

			(item.notes || []).forEach(note => {
				if (note.cid) cids.add(note.cid);
			});

			(item.modifiers || []).forEach(mod => {
				if (mod.cid) cids.add(mod.cid);
			});
		});

		return cids;
	});

	const getModifiersTotal = (item) => {
		if (!item.modifiers?.length) return 0;
		return item.modifiers.reduce((sum, mod) => {
			const price = Number(mod.price) || 0;
			return sum + price;
		}, 0);
	};

	function getRecommendedProducts() {
		const seen = new Set();
		const result = [];

		cart.value.forEach(item => {
			const recommended = item.details?.recommended || [];

			recommended.forEach(prod => {
				if (!usedCids.value.has(prod.cid) && !seen.has(prod.id)) {
					result.push(prod);
					seen.add(prod.id);
				}
			});
		});

		recommendedProducts.value = result;
	}

	watchEffect(() => {
		if (cart.value.length === 0 && !(window.self !== window.top)) {
			goBack();
		}
	});

	function goBack() {
		router.replace(makePath('/products'));
	}

	function goPay() {
		router.push(makePath('/payment'));
	}

	onMounted(() => {
		getRecommendedProducts();

		if (window.self !== window.top) {
			isDemo.value = true;

			recommendedProducts.value = [
				{ name: 'Test upsel product 1', id: 0, price: 100 },
				{ name: 'Test upsel product 2', id: 1, price: 50 }
			]
		}

		if (recommendedProducts.value.length > 0 && isDialogVisible.value) {
			isShowUpsell.value = true;
		}
	});
</script>